import React from 'react';
import { useAvatarContext } from './context';
import { FallbackLayer } from './view';

interface Props {
    children?: React.ReactNode;
}

export const AvatarFallback = ({ children }: Props) => {
    const { status, bgColor } = useAvatarContext('Avatar.Fallback');

    if (status === 'loaded') return null;

    return <FallbackLayer $bgColor={bgColor}>{children}</FallbackLayer>;
};
